            
<template>  
  <div>    
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="id_datos_pacientes">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="fecha">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="consecutivo">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_diagnosticos"
                      inputCampo="uso">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="garantia_diagnosticos"
                      inputCampo="lente">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="garantia_diagnosticos"
                      inputCampo="aumento">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="garantia_diagnosticos"
                      inputCampo="alt_bf">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="id_datos_proveedores_lente">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="color">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="filtro">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="montura">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="id_datos_proveedores_montura">
                    </sw-inputs>                   
                    <sw-inputs
                      inputTabla="garantia_diagnosticos"
                      inputCampo="observacion"
                      :lg="6"
                      :md="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="garantia_orden"
                      inputCampo="fecha_entrega">
                    </sw-inputs>
                    <b-col md="12">
                      <table class="table" style="width:100%;margin-top:10px">
                        <thead class="thead-light text-center">
                          <tr>
                            <th>RX</th>
                            <th>ESF</th>
                            <th>CIL</th>                            
                            <th>EJE</th>
                            <th>ADD</th>
                            <th>DP</th>
                          </tr>
                        </thead>
                        <tbody  class="text-center">
                          <tr >
                            <td style="font-weight:bold">OD</td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.od_esf}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.od_cil}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.od_eje}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.od_add}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.od_dp}}
                            </td>
                          </tr>
                          <tr>
                            <td style="font-weight:bold">OD</td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.oi_esf}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.oi_cil}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.oi_eje}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.oi_add}}
                            </td>
                            <td>
                              {{dataForm[namePath].garantia_diagnosticos.oi_dp}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-col>                   
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            nameBtn="registro"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  computed: 
  {
  },
  created(){
    if(this.indexData!==false)
    {  
      if(this.namePath==='orden_garantias')
      {
        this.updateDataForm({state: 'info_garantia', data: this.dataGet[this.namePath].data[this.indexData].info_garantia})
        this.updateDataForm({state: 'garantia_orden/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].info_orden.id_datos_pacientes})
        this.updateDataForm({state: 'garantia_orden/id_info_orden', data: this.dataGet[this.namePath].data[this.indexData].info_orden.id})
        this.updateDataForm({state: 'garantia_orden/consecutivo', data: this.consecutivo})
        this.updateDataForm({state: 'garantia_diagnosticos',data: this.dataGet[this.namePath].data[this.indexData].garantia_diagnosticos})
        this.updateDataForm({state: 'garantia_orden', data: 
          {
            id: "",
            id_info_garantia: this.dataGet[this.namePath].data[this.indexData].info_garantia.id,
            id_datos_pacientes: this.dataGet[this.namePath].data[this.indexData].info_orden.id_datos_pacientes,
            id_datos_proveedores_lente: this.dataGet[this.namePath].data[this.indexData].info_orden.id_datos_proveedores_lente,
            id_datos_proveedores_montura: this.dataGet[this.namePath].data[this.indexData].info_orden.id_datos_proveedores_montura,
            fecha: this.dataGet[this.namePath].data[this.indexData].info_orden.fecha,
            fecha_recibido: '',
            estado: 'producción',
            consecutivo: this.dataGet[this.namePath].data[this.indexData].info_orden.consecutivo,
            montura: this.dataGet[this.namePath].data[this.indexData].info_orden.montura,
            lente: this.dataGet[this.namePath].data[this.indexData].info_orden.lente,
            aumento: this.dataGet[this.namePath].data[this.indexData].info_orden.aumento,
            color: this.dataGet[this.namePath].data[this.indexData].info_orden.color,
            filtro: this.dataGet[this.namePath].data[this.indexData].info_orden.filtro,
            fecha_entrega: '',
          }        
        })
      }  
      if(this.namePath==='orden_pendgarantias')
      {
        this.updateDataForm({state: 'garantia_orden', data: this.dataGet[this.namePath].data[this.indexData].garantia_orden})
        this.updateDataForm({state: 'garantia_diagnosticos',data: this.dataGet[this.namePath].data[this.indexData].garantia_diagnosticos})        
      }  
    }
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'garantiaOrdenFtn' })
    }
  }
}
</script>
<style>
</style>